import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MatterAiJob } from '@models/matter';
import { Repo } from '@repos/repo.service';
import { UserProfileState } from '@state/user-profile';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { CollectionPaths } from '@models/collections';

export interface MatterDocumentsParams {
	matterId: string;
}

@Injectable({
	providedIn: 'root',
})
export class MatterAiJobServiceRepo extends Repo<
	MatterAiJob,
	MatterDocumentsParams
> {
	@SelectSnapshot(UserProfileState.getCurrentBusinessId) businessId;

	GetCollectionPath(pathParam: MatterDocumentsParams): string {
		return CollectionPaths.business_matter_aiJobs(
			this.businessId,
			pathParam.matterId,
		);
	}

	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}
}
